import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useLocalAuth } from "@/components/auth/ClerkAuthProvider";
import { Toaster } from "@/components/ui/sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import Layout from "@/components/Layout";
import { SignInPage, SignUpPage } from "@/pages/AuthPages";
import Dashboard from "@/pages/Dashboard";
import Agenda from "@/pages/Agenda";
import Patients from "@/pages/Patients";
import PatientDetail from "@/pages/PatientDetail";
import Mensalidades from "@/pages/Mensalidades";
import Finance from "@/pages/Finance";
import Reports from "@/pages/Reports";
import Marketing from "@/pages/Marketing";
import SuppliersPurchases from "@/pages/SuppliersPurchases";
import MaterialsStock from "@/pages/MaterialsStock";

const Protected = ({children}) => {
  const {token} = useLocalAuth();
  return token ? children : <Navigate to="/sign-in" replace />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ClerkAuthProvider>
          <Routes>
            <Route path="/sign-in/*" element={<SignInPage />} />
            <Route path="/sign-up/*" element={<SignUpPage />} />
            <Route path="/" element={<Protected><Layout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="agenda" element={<Agenda />} />
              <Route path="pacientes" element={<Patients />} />
              <Route path="pacientes/:id" element={<PatientDetail />} />
              <Route path="mensalidades" element={<Mensalidades />} />
              <Route path="financeiro" element={<Finance />} />
              <Route path="relatorios" element={<Reports />} />
              <Route path="marketing" element={<Marketing />} />
              <Route path="fornecedores-compras" element={<SuppliersPurchases />} />
              <Route path="materiais-estoque" element={<MaterialsStock />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </ClerkAuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
